import React, { useEffect } from 'react';
import {
    Box, Tab, Tabs, AppBar
} from '@mui/material';
import {makeStyles} from "@mui/styles";
import HomeIcon from '@mui/icons-material/Home';
import AddLocationAltIcon from "@mui/icons-material/AddLocation";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import { useLocation, useHistory } from 'react-router-dom';
const useStyles = makeStyles((theme: any) => ({
    root: {
        flexGrow: 1,
        position: "fixed",
        bottom: "0",
        width: "100%",
        maxWidth:"769px !important"
    },
    nav: {
        height: '60px'
    },
    icon: {
        width: "40%",
        height: "auto"
    },
    svgIcon: {
        width: "60%",
        paddingTop: "10px"
    },
    appBar: {
        backgroundColor: theme.color.appBarFooterBackgroundColor
    },
    colorIcon:{
        color:"white !important",
    }
}));


export default function Footer(props: any) {
    const url = useLocation().pathname;
    const history = useHistory();
    const classes = useStyles();

    const [value, setValue] = React.useState("home");

    const handleChange = (event: any, newValue: any) => {
        setValue(newValue);
    };

    useEffect(() => {
        if (url.indexOf('home') > -1) {
            setValue('home');
        }
        else if (url.indexOf('setting') > -1)
            setValue('setting')
        else if (url.indexOf('performance') > -1)
            setValue('performance')

    }, [url])
    return (

        <Box className={classes.root}  >
            <AppBar position="static" className={classes.appBar}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="secondary"
                    textColor="inherit"
                    variant="fullWidth"
                    className={classes.nav}
                    aria-label="full width tabs example"
                >
                    <Tab value="performance" icon={<ShoppingBasketIcon fontSize="large" className={classes.colorIcon} />} onClick={e => { history.push('/app/propertyPackages') }} />
                    <Tab value="home" icon={<HomeIcon fontSize="large" className={classes.colorIcon} />} onClick={e => { history.push('/app/fieldList') }} />
                    <Tab value="setting" icon={<AddLocationAltIcon fontSize="large" className={classes.colorIcon} />} onClick={e => { history.push('/app/addAttendance') }} />
                </Tabs>
            </AppBar>

        </Box>
    );
}
